import {
  HammerGestureConfig,
} from '@angular/platform-browser';

export class MyHammerConfig extends HammerGestureConfig {
  overrides =  {
    pinch: { enable: false },
    rotate: { enable: false },
  } as any;
}
